module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow-9a3e2bde894a74a8456976070b2162d4.svg";